import React from 'react';
import { Brain, Heart, Shield, Activity, DollarSign, Users } from 'lucide-react';
import { motion } from 'framer-motion';

const interests = [
  { value: 'health', label: 'Health & Wellness', icon: Heart },
  { value: 'fitness', label: 'Fitness', icon: Activity },
  { value: 'finance', label: 'Financial Planning', icon: DollarSign },
  { value: 'personal', label: 'Personal Development', icon: Brain },
  { value: 'social', label: 'Social Connection', icon: Users },
  { value: 'security', label: 'Life Security', icon: Shield }
];

interface InterestSelectorProps {
  selectedInterests: string[];
  onChange: (interests: string[]) => void;
}

export const InterestSelector: React.FC<InterestSelectorProps> = ({
  selectedInterests,
  onChange
}) => {
  const handleToggle = (value: string) => {
    const newInterests = selectedInterests.includes(value)
      ? selectedInterests.filter(i => i !== value)
      : [...selectedInterests, value];
    onChange(newInterests);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-400 mb-2">
        Areas of Interest
      </label>
      <div className="grid grid-cols-3 gap-4">
        {interests.map(({ value, label, icon: Icon }) => (
          <motion.button
            key={value}
            type="button"
            onClick={() => handleToggle(value)}
            className={`glass p-4 flex items-center space-x-3 transition-colors ${
              selectedInterests.includes(value)
                ? 'border-2 border-neon-green'
                : 'border border-white/10 hover:border-white/20'
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Icon className={selectedInterests.includes(value) ? 'text-neon-green' : 'text-gray-400'} />
            <span>{label}</span>
          </motion.button>
        ))}
      </div>
    </div>
  );
};